import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@pps/ui/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

/**
 * Tela exibida por `RequirePermission` quando o usuário não tem a
 * permissão exigida pela rota. Mesmo padrão visual de `PlanGate.tsx`
 * (cadeado + card centralizado), mas sem CTA de upgrade — aqui o problema é
 * papel/permissão, não plano.
 */
export function NoPermission() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <Card className="max-w-md w-full">
        <CardContent className="flex flex-col items-center gap-4 pt-8 pb-8 text-center">
          <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center">
            <Lock className="h-8 w-8 text-muted-foreground" />
          </div>
          <h2 className="text-xl font-semibold text-foreground">
            {t('noPermission.title')}
          </h2>
          <p className="text-sm text-muted-foreground">
            {t('noPermission.description')}
          </p>
          <Button onClick={() => navigate('/')} className="mt-2">
            {t('noPermission.backCta')}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
